import { render, staticRenderFns } from "./initNode.vue?vue&type=template&id=bd2251a2&scoped=true&"
import script from "./initNode.vue?vue&type=script&lang=js&"
export * from "./initNode.vue?vue&type=script&lang=js&"
import style0 from "./initNode.vue?vue&type=style&index=0&id=bd2251a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2251a2",
  null
  
)

export default component.exports